export const LIVE_MODE_HELP_TEXT_VSI =
  'Metric Summary: sliding window 1-min, refreshes every 10s. Time-series: last 15 minutes.';

export const LIVE_MODE_HELP_TEXT_APP =
  'Metric Summary: sliding window 15-min, refreshes every 10s. Time-series: last 15 minutes.';
